var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "section" }, [
    _c("div", { staticClass: "container" }, [
      _c(
        "div",
        { staticClass: "level" },
        [
          _c(
            "Header",
            _vm._b(
              { staticClass: "level-left" },
              "Header",
              _vm.$route.meta,
              false
            )
          ),
        ],
        1
      ),
      _c("div", { staticClass: "columns" }, [
        _c(
          "div",
          { staticClass: "column" },
          [
            _c("ag-grid-vue", {
              staticClass: "ag-theme-balham",
              staticStyle: { width: "100%", height: "700px" },
              attrs: {
                "grid-options": _vm.gridOptions,
                pagination: true,
                "pagination-auto-page-size": true,
                "cache-overflow-size": 0,
                "multi-sort-key": "ctrl",
                "get-child-count": _vm.getChildCount,
                modules: _vm.modules,
                "get-context-menu-items": _vm.getContextMenuItems,
              },
              on: { "grid-ready": _vm.gridReady },
            }),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }